import { normalizePathname } from '../../../routing'
import { stripLocalePrefix } from '../../../../i18n/shopLocale'

export const replaceLocalizedPathIfNeeded = ({
  nextPath,
  toLocalizedCanonical,
}: {
  nextPath: string
  toLocalizedCanonical: (path: string) => string
}) => {
  const { pathnameWithoutLocale } = stripLocalePrefix(window.location.pathname)
  if (normalizePathname(pathnameWithoutLocale) === nextPath) return
  window.history.replaceState({}, '', toLocalizedCanonical(nextPath))
}

export const replaceLocalizedTargetIfNeeded = ({
  nextTarget,
  toLocalizedCanonical,
}: {
  nextTarget: string
  toLocalizedCanonical: (path: string) => string
}) => {
  const { pathnameWithoutLocale } = stripLocalePrefix(window.location.pathname)
  const currentTarget = `${normalizePathname(pathnameWithoutLocale)}${window.location.search}`
  if (currentTarget === nextTarget) return
  window.history.replaceState({}, '', toLocalizedCanonical(nextTarget))
}
